module.exports = __webpack_public_path__ + "img/save.8755ab73.svg";